import { render, staticRenderFns } from "./hospital-manage.vue?vue&type=template&id=fc883f84&"
import script from "./hospital-manage.vue?vue&type=script&lang=ts&"
export * from "./hospital-manage.vue?vue&type=script&lang=ts&"
import style0 from "./hospital-manage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports